import * as React from "react";
import qs from "qs";
import { useAsyncEffect, useRouter } from "@relode/core";

import { DashboardActions } from "./dashboardActions";
import { DashboardState } from "./dashboardState";

export const useDashboardHandlers = (
    state: DashboardState,
    dashboardActions: DashboardActions
) => {
    const {
        location: { search },
    } = useRouter();

    useAsyncEffect(async () => {
        const params = qs.parse(search, { ignoreQueryPrefix: true });
        await dashboardActions.loadJobManagerDetails();
        await dashboardActions.loadDashboardType(params.showAll === "true");
    }, [search]);
};
